export const advisorActorType = {
  Cpa: 'cpa',
  Customer: 'customer',
} as const

export const advisorAppArea = {
  Expert: 'expert',
  Client: 'client',
  Practice: 'practice',
} as const
